<template>
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="-25.364 -24.487 493.228 476.222"
    enable-background="new -25.364 -24.487 493.228 476.222"
  >
 <g v-if="logoStyle === 'normal'">
  <path fill="#E75E0D" d="M221.222,79.56l39.645,75.308l11.223,21.342l23.721,4.425l78.407,14.598l-56.896,54.133l-20.017,19.075
    l5.641,27.093l15.924,76.804l-76.637-35.609l-21.012-9.786l-21.013,9.786l-76.525,35.666l15.923-76.804l5.642-27.093
    l-20.016-19.076l-56.896-54.133l78.405-14.597l23.721-4.423l11.224-21.342L221.222,79.56 M222.991-12.449h-3.539
    c-3.925,0.055-7.465,2.321-9.125,5.861l-72.765,138.232l-152.719,28.476c-4.204,0.055-7.963,2.599-9.51,6.525
    c-1.493,3.925-0.553,8.348,2.487,11.224L90.842,285.415L58.826,439.793c-0.664,3.871,0.996,7.74,4.203,10.008
    c1.274,0.885,2.656,1.438,4.093,1.715c0.608,0.11,1.217,0.164,1.881,0.164c1.658,0,3.372-0.389,4.921-1.217l147.3-68.619
    l147.357,68.674c1.548,0.829,3.207,1.217,4.922,1.217c0.607,0,1.271-0.056,1.88-0.166c1.437-0.276,2.818-0.829,4.091-1.713
    c3.207-2.267,4.811-6.138,4.204-10.008L351.66,285.47l113.02-107.547c3.041-2.874,3.981-7.354,2.486-11.223
    c-1.548-3.925-5.308-6.469-9.509-6.525l-152.72-28.476L232.173-6.537C230.511-10.128,226.917-12.394,222.991-12.449"/>
  <path fill="#E75E0D" d="M316.216-6.7c-0.664-10.45-9.621-18.413-20.072-17.749c-10.449,0.663-18.412,9.621-17.749,20.072
    c0.166,2.819,13.104,45.783,13.104,45.783c1.052,4.147,4.922,7.131,9.347,6.856c4.425-0.276,7.963-3.704,8.458-7.963h0.166
    C309.526,40.299,316.382-4.045,316.216-6.7"/>
  <path fill="#E75E0D" d="M375.989,11.16c3.981-9.676-0.608-20.736-10.229-24.717c-9.676-3.98-20.735,0.609-24.771,10.286
    c-1.105,2.6-8.241,46.888-8.241,46.888c-0.885,4.204,1.273,8.569,5.419,10.285c4.092,1.715,8.736,0.166,11.113-3.428l0.167,0.055
    C349.393,50.418,374.993,13.593,375.989,11.16"/>
  <path fill="#E75E0D" d="M422.323,54.29c7.852-6.911,8.569-18.91,1.603-26.763c-6.91-7.852-18.91-8.569-26.763-1.603
    c-2.101,1.88-27.978,38.538-27.978,38.538c-2.654,3.373-2.599,8.294,0.332,11.613s7.797,3.98,11.501,1.77l0.111,0.11
    C381.186,77.955,420.333,56.059,422.323,54.29"/>
  <path fill="#E75E0D" d="M445.933,113.397c10.062-2.82,15.979-13.215,13.162-23.334c-2.82-10.062-13.216-15.979-23.337-13.162
    c-2.709,0.775-42.023,22.338-42.023,22.338c-3.868,1.882-5.968,6.304-4.753,10.562c1.216,4.312,5.252,6.966,9.564,6.634
    l0.057,0.166C398.548,116.604,443.334,114.118,445.933,113.397"/>
</g>

  <g v-if="logoStyle === 'mono'">
    <path fill="#FFFFFF" d="M221.222,79.56l39.645,75.308l11.223,21.342l23.721,4.425l78.407,14.598l-56.896,54.133l-20.017,19.075
    l5.641,27.093l15.924,76.804l-76.637-35.609l-21.012-9.786l-21.013,9.786l-76.525,35.666l15.923-76.804l5.642-27.093
    l-20.016-19.076l-56.896-54.133l78.405-14.597l23.721-4.423l11.224-21.342L221.222,79.56 M222.991-12.449h-3.539
    c-3.925,0.055-7.465,2.321-9.125,5.861l-72.765,138.232l-152.719,28.476c-4.204,0.055-7.963,2.599-9.51,6.525
    c-1.493,3.925-0.553,8.348,2.487,11.224L90.842,285.415L58.826,439.793c-0.664,3.871,0.996,7.74,4.203,10.008
    c1.274,0.885,2.656,1.438,4.093,1.715c0.608,0.11,1.217,0.164,1.881,0.164c1.658,0,3.372-0.389,4.921-1.217l147.3-68.619
    l147.357,68.674c1.548,0.829,3.207,1.217,4.922,1.217c0.607,0,1.271-0.056,1.88-0.166c1.437-0.276,2.818-0.829,4.091-1.713
    c3.207-2.267,4.811-6.138,4.204-10.008L351.66,285.47l113.02-107.547c3.041-2.874,3.981-7.354,2.486-11.223
    c-1.548-3.925-5.308-6.469-9.509-6.525l-152.72-28.476L232.173-6.537C230.511-10.128,226.917-12.394,222.991-12.449"/>
  <path fill="#FFFFFF" d="M316.216-6.7c-0.664-10.45-9.621-18.413-20.072-17.749c-10.449,0.663-18.412,9.621-17.749,20.072
    c0.166,2.819,13.104,45.783,13.104,45.783c1.052,4.147,4.922,7.131,9.347,6.856c4.425-0.276,7.963-3.704,8.458-7.963h0.166
    C309.526,40.299,316.382-4.045,316.216-6.7"/>
  <path fill="#FFFFFF" d="M375.989,11.16c3.981-9.676-0.608-20.736-10.229-24.717c-9.676-3.98-20.735,0.609-24.771,10.286
    c-1.105,2.6-8.241,46.888-8.241,46.888c-0.885,4.204,1.273,8.569,5.419,10.285c4.092,1.715,8.736,0.166,11.113-3.428l0.167,0.055
    C349.393,50.418,374.993,13.593,375.989,11.16"/>
  <path fill="#FFFFFF" d="M422.323,54.29c7.852-6.911,8.569-18.91,1.603-26.763c-6.91-7.852-18.91-8.569-26.763-1.603
    c-2.101,1.88-27.978,38.538-27.978,38.538c-2.654,3.373-2.599,8.294,0.332,11.613s7.797,3.98,11.501,1.77l0.111,0.11
    C381.186,77.955,420.333,56.059,422.323,54.29"/>
  <path fill="#FFFFFF" d="M445.933,113.397c10.062-2.82,15.979-13.215,13.162-23.334c-2.82-10.062-13.216-15.979-23.337-13.162
    c-2.709,0.775-42.023,22.338-42.023,22.338c-3.868,1.882-5.968,6.304-4.753,10.562c1.216,4.312,5.252,6.966,9.564,6.634
    l0.057,0.166C398.548,116.604,443.334,114.118,445.933,113.397"/>
  </g>

  <g v-if="logoStyle === 'feminista'">
    <path fill="#FFFFFF" d="M221.222,79.56l39.645,75.308l11.223,21.342l23.721,4.425l78.407,14.598l-56.896,54.133l-20.017,19.075
    l5.641,27.093l15.924,76.804l-76.637-35.609l-21.012-9.786l-21.013,9.786l-76.525,35.666l15.923-76.804l5.642-27.093
    l-20.016-19.076l-56.896-54.133l78.405-14.597l23.721-4.423l11.224-21.342L221.222,79.56 M222.991-12.449h-3.539
    c-3.925,0.055-7.465,2.321-9.125,5.861l-72.765,138.232l-152.719,28.476c-4.204,0.055-7.963,2.599-9.51,6.525
    c-1.493,3.925-0.553,8.348,2.487,11.224L90.842,285.415L58.826,439.793c-0.664,3.871,0.996,7.74,4.203,10.008
    c1.274,0.885,2.656,1.438,4.093,1.715c0.608,0.11,1.217,0.164,1.881,0.164c1.658,0,3.372-0.389,4.921-1.217l147.3-68.619
    l147.357,68.674c1.548,0.829,3.207,1.217,4.922,1.217c0.607,0,1.271-0.056,1.88-0.166c1.437-0.276,2.818-0.829,4.091-1.713
    c3.207-2.267,4.811-6.138,4.204-10.008L351.66,285.47l113.02-107.547c3.041-2.874,3.981-7.354,2.486-11.223
    c-1.548-3.925-5.308-6.469-9.509-6.525l-152.72-28.476L232.173-6.537C230.511-10.128,226.917-12.394,222.991-12.449"/>
  <path fill="#FFFFFF" d="M316.216-6.7c-0.664-10.45-9.621-18.413-20.072-17.749c-10.449,0.663-18.412,9.621-17.749,20.072
    c0.166,2.819,13.104,45.783,13.104,45.783c1.052,4.147,4.922,7.131,9.347,6.856c4.425-0.276,7.963-3.704,8.458-7.963h0.166
    C309.526,40.299,316.382-4.045,316.216-6.7"/>
  <path fill="#FFFFFF" d="M375.989,11.16c3.981-9.676-0.608-20.736-10.229-24.717c-9.676-3.98-20.735,0.609-24.771,10.286
    c-1.105,2.6-8.241,46.888-8.241,46.888c-0.885,4.204,1.273,8.569,5.419,10.285c4.092,1.715,8.736,0.166,11.113-3.428l0.167,0.055
    C349.393,50.418,374.993,13.593,375.989,11.16"/>
  <path fill="#FFFFFF" d="M422.323,54.29c7.852-6.911,8.569-18.91,1.603-26.763c-6.91-7.852-18.91-8.569-26.763-1.603
    c-2.101,1.88-27.978,38.538-27.978,38.538c-2.654,3.373-2.599,8.294,0.332,11.613s7.797,3.98,11.501,1.77l0.111,0.11
    C381.186,77.955,420.333,56.059,422.323,54.29"/>
  <path fill="#FFFFFF" d="M445.933,113.397c10.062-2.82,15.979-13.215,13.162-23.334c-2.82-10.062-13.216-15.979-23.337-13.162
    c-2.709,0.775-42.023,22.338-42.023,22.338c-3.868,1.882-5.968,6.304-4.753,10.562c1.216,4.312,5.252,6.966,9.564,6.634
    l0.057,0.166C398.548,116.604,443.334,114.118,445.933,113.397"/>
  </g>

  <g v-if="logoStyle === 'lgtb'">
    <path fill="#FFFFFF" d="M221.222,79.56l39.645,75.308l11.223,21.342l23.721,4.425l78.407,14.598l-56.896,54.133l-20.017,19.075
    l5.641,27.093l15.924,76.804l-76.637-35.609l-21.012-9.786l-21.013,9.786l-76.525,35.666l15.923-76.804l5.642-27.093
    l-20.016-19.076l-56.896-54.133l78.405-14.597l23.721-4.423l11.224-21.342L221.222,79.56 M222.991-12.449h-3.539
    c-3.925,0.055-7.465,2.321-9.125,5.861l-72.765,138.232l-152.719,28.476c-4.204,0.055-7.963,2.599-9.51,6.525
    c-1.493,3.925-0.553,8.348,2.487,11.224L90.842,285.415L58.826,439.793c-0.664,3.871,0.996,7.74,4.203,10.008
    c1.274,0.885,2.656,1.438,4.093,1.715c0.608,0.11,1.217,0.164,1.881,0.164c1.658,0,3.372-0.389,4.921-1.217l147.3-68.619
    l147.357,68.674c1.548,0.829,3.207,1.217,4.922,1.217c0.607,0,1.271-0.056,1.88-0.166c1.437-0.276,2.818-0.829,4.091-1.713
    c3.207-2.267,4.811-6.138,4.204-10.008L351.66,285.47l113.02-107.547c3.041-2.874,3.981-7.354,2.486-11.223
    c-1.548-3.925-5.308-6.469-9.509-6.525l-152.72-28.476L232.173-6.537C230.511-10.128,226.917-12.394,222.991-12.449"/>
  <path fill="#FFFFFF" d="M316.216-6.7c-0.664-10.45-9.621-18.413-20.072-17.749c-10.449,0.663-18.412,9.621-17.749,20.072
    c0.166,2.819,13.104,45.783,13.104,45.783c1.052,4.147,4.922,7.131,9.347,6.856c4.425-0.276,7.963-3.704,8.458-7.963h0.166
    C309.526,40.299,316.382-4.045,316.216-6.7"/>
  <path fill="#FFFFFF" d="M375.989,11.16c3.981-9.676-0.608-20.736-10.229-24.717c-9.676-3.98-20.735,0.609-24.771,10.286
    c-1.105,2.6-8.241,46.888-8.241,46.888c-0.885,4.204,1.273,8.569,5.419,10.285c4.092,1.715,8.736,0.166,11.113-3.428l0.167,0.055
    C349.393,50.418,374.993,13.593,375.989,11.16"/>
  <path fill="#FFFFFF" d="M422.323,54.29c7.852-6.911,8.569-18.91,1.603-26.763c-6.91-7.852-18.91-8.569-26.763-1.603
    c-2.101,1.88-27.978,38.538-27.978,38.538c-2.654,3.373-2.599,8.294,0.332,11.613s7.797,3.98,11.501,1.77l0.111,0.11
    C381.186,77.955,420.333,56.059,422.323,54.29"/>
  <path fill="#FFFFFF" d="M445.933,113.397c10.062-2.82,15.979-13.215,13.162-23.334c-2.82-10.062-13.216-15.979-23.337-13.162
    c-2.709,0.775-42.023,22.338-42.023,22.338c-3.868,1.882-5.968,6.304-4.753,10.562c1.216,4.312,5.252,6.966,9.564,6.634
    l0.057,0.166C398.548,116.604,443.334,114.118,445.933,113.397"/>
  </g>

  <g v-if="logoStyle === 'quatri'">
    <path fill="#FFFFFF" d="M221.222,79.56l39.645,75.308l11.223,21.342l23.721,4.425l78.407,14.598l-56.896,54.133l-20.017,19.075
    l5.641,27.093l15.924,76.804l-76.637-35.609l-21.012-9.786l-21.013,9.786l-76.525,35.666l15.923-76.804l5.642-27.093
    l-20.016-19.076l-56.896-54.133l78.405-14.597l23.721-4.423l11.224-21.342L221.222,79.56 M222.991-12.449h-3.539
    c-3.925,0.055-7.465,2.321-9.125,5.861l-72.765,138.232l-152.719,28.476c-4.204,0.055-7.963,2.599-9.51,6.525
    c-1.493,3.925-0.553,8.348,2.487,11.224L90.842,285.415L58.826,439.793c-0.664,3.871,0.996,7.74,4.203,10.008
    c1.274,0.885,2.656,1.438,4.093,1.715c0.608,0.11,1.217,0.164,1.881,0.164c1.658,0,3.372-0.389,4.921-1.217l147.3-68.619
    l147.357,68.674c1.548,0.829,3.207,1.217,4.922,1.217c0.607,0,1.271-0.056,1.88-0.166c1.437-0.276,2.818-0.829,4.091-1.713
    c3.207-2.267,4.811-6.138,4.204-10.008L351.66,285.47l113.02-107.547c3.041-2.874,3.981-7.354,2.486-11.223
    c-1.548-3.925-5.308-6.469-9.509-6.525l-152.72-28.476L232.173-6.537C230.511-10.128,226.917-12.394,222.991-12.449"/>
  <path fill="#FFFFFF" d="M316.216-6.7c-0.664-10.45-9.621-18.413-20.072-17.749c-10.449,0.663-18.412,9.621-17.749,20.072
    c0.166,2.819,13.104,45.783,13.104,45.783c1.052,4.147,4.922,7.131,9.347,6.856c4.425-0.276,7.963-3.704,8.458-7.963h0.166
    C309.526,40.299,316.382-4.045,316.216-6.7"/>
  <path fill="#FFFFFF" d="M375.989,11.16c3.981-9.676-0.608-20.736-10.229-24.717c-9.676-3.98-20.735,0.609-24.771,10.286
    c-1.105,2.6-8.241,46.888-8.241,46.888c-0.885,4.204,1.273,8.569,5.419,10.285c4.092,1.715,8.736,0.166,11.113-3.428l0.167,0.055
    C349.393,50.418,374.993,13.593,375.989,11.16"/>
  <path fill="#FFFFFF" d="M422.323,54.29c7.852-6.911,8.569-18.91,1.603-26.763c-6.91-7.852-18.91-8.569-26.763-1.603
    c-2.101,1.88-27.978,38.538-27.978,38.538c-2.654,3.373-2.599,8.294,0.332,11.613s7.797,3.98,11.501,1.77l0.111,0.11
    C381.186,77.955,420.333,56.059,422.323,54.29"/>
  <path fill="#FFFFFF" d="M445.933,113.397c10.062-2.82,15.979-13.215,13.162-23.334c-2.82-10.062-13.216-15.979-23.337-13.162
    c-2.709,0.775-42.023,22.338-42.023,22.338c-3.868,1.882-5.968,6.304-4.753,10.562c1.216,4.312,5.252,6.966,9.564,6.634
    l0.057,0.166C398.548,116.604,443.334,114.118,445.933,113.397"/>
  </g>
</svg>
</template>

<script>
export default {
  name: 'careta',

  props: {
    logoStyle: {
      type: String,
      default: 'mono',
      validator: (value) => {
        return ['mono', 'normal', 'feminista', 'lgtb', 'quatri'].includes(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .st0 { fill: #FFFFFF; }
  .st1 { fill: url(#compromisGradient); }
  .st2 { fill: url(#feministaGradient); }
  .st3 { clip-path:url(#SVGID_4_); }
  .st4 { fill: #EF404D; }
  .st5 { fill: #F79226; }
  .st6 { fill: #FFD10F; }
  .st7 { fill: #7FC347; }
  .st8 { fill: #55A4DB; }
  .st9 { fill: #A14A9C; }
  .st10 { fill:url(#SVGID_5_); }
  .st11 { fill:url(#SVGID_6_); }
  .st12 { clip-path:url(#SVGID_8_); }
</style>
